import script from "./Status.vue?vue&type=script&lang=ts&setup=true"
export * from "./Status.vue?vue&type=script&lang=ts&setup=true"

import "./Status.vue?vue&type=style&index=0&id=656d904a&lang=scss&scoped=true"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656d904a"]])

export default __exports__